<div class="card m-2">
    <app-edit-history [options]="editHistoryOptions" [data]="editHistoyData" ></app-edit-history>
</div>

<!-- <div class="card m-2">

    <app-custom-tabs
        [fields]="tabsField" [options]="tabOptions"
    >

    </app-custom-tabs>

</div> -->


<div class="card m-2">

  <app-custom-steps
      
  >

  </app-custom-steps>

</div>


<div class="card m-2">
    <router-outlet></router-outlet>
</div>
